import { render } from "./ModalAvisoGenerico.vue?vue&type=template&id=93162536&scoped=true"
import script from "./ModalAvisoGenerico.vue?vue&type=script&lang=js"
export * from "./ModalAvisoGenerico.vue?vue&type=script&lang=js"

import "./ModalAvisoGenerico.vue?vue&type=style&index=0&id=93162536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93162536"]])

export default __exports__